export default "__VITE_ASSET__1XYffwuP__"